const boardEventTypes = ['BoardUpdated'] as const;
const statusEventTypes = [
  'StatusCreated',
  'StatusDeleted',
  'StatusOrderUpdated',
  'StatusUpdated',
] as const;
const taskEventTypes = [
  'TaskArchived',
  'TaskCreated',
  'TaskUnarchived',
  'TaskUpdated',
  'TasksArchived',
  'TasksOrderUpdated',
  'TasksUpdated',
] as const;
const connectionEventTypes = [
  'ConnectionCreated',
  'ConnectionDeleted',
  'ConnectionUpdated',
] as const;

const boardEventTypeSet = new Set<string>(boardEventTypes);
const statusEventTypeSet = new Set<string>(statusEventTypes);
const taskEventTypeSet = new Set<string>(taskEventTypes);
const connectionEventTypeSet = new Set<string>(connectionEventTypes);

export const isBoardSignalREventType = (eventType: string): boolean => {
  return boardEventTypeSet.has(eventType);
};

export const isStatusSignalREventType = (eventType: string): boolean => {
  return statusEventTypeSet.has(eventType);
};

export const isTaskSignalREventType = (eventType: string): boolean => {
  return taskEventTypeSet.has(eventType);
};

export const isConnectionSignalREventType = (eventType: string): boolean => {
  return connectionEventTypeSet.has(eventType);
};

export const isBoardScreenTaskRefreshEventType = (eventType: string): boolean => {
  return isTaskSignalREventType(eventType) || eventType === 'StatusDeleted';
};

export const isNumbersSignalREventType = (eventType: string): boolean => {
  return (
    isTaskSignalREventType(eventType) ||
    isStatusSignalREventType(eventType) ||
    isConnectionSignalREventType(eventType)
  );
};

export const isConnectionsSignalREventType = (eventType: string): boolean => {
  return (
    isBoardSignalREventType(eventType) ||
    isStatusSignalREventType(eventType) ||
    isConnectionSignalREventType(eventType)
  );
};